import { Button } from "components/ui/button/Button";
import "./welcome-v-one.scss";
import { ReactComponent as WelcomeGraphicDesktop } from "assets/images/WelcomeGraphicDesktop.svg";
import { ReactComponent as WelcomeGraphicMobile } from "assets/images/WelcomeGraphicMobile.svg";
import { useCreateApplicationMutation, CreateApplicationTemplateRequest } from "pages/welcome/welcomePathService";
import { LoadingOverlay } from "components/ui/loading-spinners";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getCurrentUserId,
  setApplicationId,
  setLogout,
  getNhDealApplicationId,
  setNhApplicationStatus,
  getIsCoBorrowerHasOwnNhApplication,
  getUserRole,
  getNhApplicationPath,
  setIsConsentCollected,
} from "features/authSlice";
import Footer from "components/footer/Footer";
import useDesktopChecker from "hooks/useDesktopChecker";
import { RegistrationRoleType } from "pages/registration/registrationService";
import { Consent } from "components/consent/Consent";
import * as Constant from "utilities/Constant";
import { useState } from "react";
import RedesignAnnouncementModal from "pages/announcements/re-design/re-design-modal";

export default function WelcomeVersonOne({ setPath }: { readonly setPath: (path: string) => void }) {
  const [
    CreateApplication,
    { data, isSuccess, isError: isCreateApplicationError, isLoading: createApplicationLoading, error: createApplicationError },
  ] = useCreateApplicationMutation();
  const isDesktop = useDesktopChecker();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = useSelector(getCurrentUserId);
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dispatch = useDispatch();
  const userRole = useSelector(getUserRole);
  const isCoBorrowerHasOwnApp = useSelector(getIsCoBorrowerHasOwnNhApplication);
  const nhApplicationPath = useSelector(getNhApplicationPath);
  const isSpouseWithApplication =
    userRole.toLowerCase() === RegistrationRoleType.SpousalCoBorrower.toLowerCase() && isCoBorrowerHasOwnApp;
  const pathType = isSpouseWithApplication ? nhApplicationPath : "FullPath";
  const handleOnSubmit = async () => {
    const RequestBody: CreateApplicationTemplateRequest = {
      pathType: pathType === "unknown" ? "FullPath" : pathType,
    };
    setPath(pathType);
    await CreateApplication({
      createApplicationTemplate: RequestBody,
      userId,
      nhDealApplicationId,
    });
  };
  if (isSuccess && data) {
    const nhApplicationStatus = "inProgress";
    dispatch(setIsConsentCollected(true));
    dispatch(setApplicationId(data));
    dispatch(setNhApplicationStatus(nhApplicationStatus));
    navigate("/application", { replace: true });
  } else if (isCreateApplicationError) {
    if (typeof createApplicationError === "object" && "status" in createApplicationError && (createApplicationError.status === 401 || createApplicationError.status === 500)) {
        dispatch(setLogout());
        navigate("/", { replace: true, state: { path: location.pathname } });
    }
  }

  if (createApplicationLoading) return <LoadingOverlay />;
  return (
    <>
      <RedesignAnnouncementModal />
      <div className="welcome-page">
        <div className="welcome-container">
          <div className="welcome-content-section">
            <div className="welcome-page_title">{Constant.welcomeHeader}</div>
            <div className="welcome-page_description">
              <p className="welcome-page_description__one">{Constant.welcomeSubtext}</p>
            </div>
            <div className="welcome-page_graphic">{isDesktop ? <WelcomeGraphicDesktop /> : <WelcomeGraphicMobile />}</div>
          </div>
          <div className="welcome-actions-section">
            <Button
              className="welcome-page_button"
              title="Continue"
              disabled={isSubmitted}
              onClick={() => {
                setIsSubmitted(true);
                void handleOnSubmit();
              }}
            />
            <Consent text={Constant.WELCOME_PAGE_CONSENT} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
